import React from "react"
import HomeUI from "../../ui/homeUI/_index";

const HighManager = () => {
  return (
    <HomeUI />
  )
}

export default HighManager